import React from 'react';
import { FormattedMessage } from 'react-intl';

const AboutUs = ({ lang }) => {
  return (
    <section id="about" className={'section main-padding'}>
      <div>
        <div className="position-relative text-center  mb-5 mt-5">
          <p className={'text-9 text-dark fw-600 text-start'}>
            <FormattedMessage id="about-us" defaultMessage="Know us more" />
            <span className="heading-separator-line border-bottom border-3 border-primary d-block" />
          </p>
        </div>
        <div className="row gy-5">
          <div className="text-center text-lg-start">
            <h2 className={'text-7 fw-600 mb-3 '}>
              <FormattedMessage id="about-weare" defaultMessage="We are" />
              <span className="text-primary"> Go-Numerik</span>
            </h2>
            <p className="text-start">
              <FormattedMessage
                id="about-more"
                defaultMessage="We are a team of IT professionals with expertise at all levels of digital systems implementation. From analysis to implementation and securing modern and flexible systems that take into account the evolution of your business models. Our technical expertise covers areas such as the banking sector, insurance, and retail commerce"
              />
            </p>
            <div className="businiess-process">
              <img
                src={lang === 'en' ? 'images/bme.png' : 'images/bmf.png'}
                width="80%"
                alt="simplified business model"
              />
            </div>
          </div>
        </div>
        {/* projects rewards counting start */}
        <div
          className={'brands-grid separator-border mt-5 separator-border-ligh'}>
          <div className="row">
            <div className="col-6 col-md-3">
              <div className="featured-box text-center">
                <h4 className={'text-12  mb-0'}>
                  <span>10</span>+
                </h4>
                <p className={'mb-0'}>
                  <FormattedMessage
                    id="about-experience"
                    defaultMessage="Years Experience"
                  />
                </p>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="featured-box text-center">
                <h4 className={'text-12  mb-0'}>
                  <span>50</span>+
                </h4>
                <p className={'mb-0'}>
                  <FormattedMessage
                    id="about-client"
                    defaultMessage="Happy clients"
                  />
                </p>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="featured-box text-center">
                <h4 className={'text-12  mb-0 '}>
                  <span>75</span>+
                </h4>
                <p className={'mb-0'}>
                  <FormattedMessage
                    id="about-project"
                    defaultMessage="Projects Done"
                  />
                </p>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="featured-box text-center">
                <h4 className={'text-12  mb-0 '}>
                  <span>10</span>
                </h4>
                <p className={'mb-0'}>
                  {' '}
                  <FormattedMessage
                    id="about-awards"
                    defaultMessage="Get Awards"
                  />
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* projects rewards counting end */}
      </div>
    </section>
  );
};

export default AboutUs;
